import { render, staticRenderFns } from "./AutorTimelineItem.vue?vue&type=template&id=1b8c2dcd&scoped=true"
import script from "./AutorTimelineItem.vue?vue&type=script&lang=js"
export * from "./AutorTimelineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c2dcd",
  null
  
)

export default component.exports